import ChartBase from "@/components/Elements/Charts/ChartBase";

import { useDonutChartOptions } from "./useDonutChartOptions";

const DonutChart = ({
  data = [],
  controlled,
  onLegendSelectChange,
  formatTotal = (total) => total,
  formatName = (name) => name,
  formatLabel = ({ value }) => value,
  formatTooltipValue = (value) => value,
  chartLeftPosition,
  hideLegend = false,
  hideTotal = false,
  hideLabels = false,
  customOptions = {},
  ...chartBaseProps
}) => {
  const options = useDonutChartOptions({
    data,
    formatTotal,
    formatName,
    formatLabel,
    formatTooltipValue,
    controlled,
    chartLeftPosition,
    hideLegend,
    hideTotal,
    hideLabels,
    customOptions,
  });

  return (
    <ChartBase
      {...chartBaseProps}
      options={options}
      onLegendSelectChange={onLegendSelectChange}
      reverseLegendSelection
    />
  );
};

export default DonutChart;
